import { createReducer } from '@reduxjs/toolkit';

import getEbayTasks from '../../thunks/ebay/getEbayTasks';

const initialState = {
  loading: false,
  error: null,
  data: undefined,
};

const getEbayTasksReducer = createReducer(initialState, {
  [getEbayTasks.pending]: (state) => ({
    ...state,
    loading: true,
    error: null
  }),
  [getEbayTasks.fulfilled]: (state, { payload: { tasks, total } }) => ({
    ...state,
    loading: false,
    data: tasks,
    total
  }),
  [getEbayTasks.rejected]: (state, { payload }) => ({
    ...state,
    loading: false,
    error: payload,
  }),
});

export default getEbayTasksReducer;
